import { render, staticRenderFns } from "./UserPriceList.vue?vue&type=template&id=2a99289c&scoped=true&"
import script from "./UserPriceList.vue?vue&type=script&lang=js&"
export * from "./UserPriceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a99289c",
  null
  
)

export default component.exports